import React from 'react';

import { Box } from '@mui/joy';
import { useColorScheme } from '@mui/joy/styles';

import step2PreviewDark from '../../../assets/onboarding/queue-step2-preview-dark.png';
import step2Preview from '../../../assets/onboarding/queue-step2-preview.png';
import type { BenefitCounter } from '../../../stores/schemas/userMe';

// Onboarding Step 2 preview — exported DIRECTLY from the Figma node as an image
// rather than pixel-coded. The two stat tiles are illustrative (static, matching
// the design). Light = node 465:81466; dark = node 661:154933 (both 534x270 @3x)
// — swapped by theme. The `fastpass` prop is kept for call-site compatibility.
export const QueueStep2Preview: React.FC<{ fastpass?: BenefitCounter | null }> = () => {
  const { mode, systemMode } = useColorScheme();
  const isDark = (mode === 'system' ? systemMode : mode) === 'dark';
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        component='img'
        src={isDark ? step2PreviewDark : step2Preview}
        alt=''
        // 534x270; scaled responsively.
        sx={{ width: 534, maxWidth: '100%', height: 'auto', display: 'block' }}
      />
    </Box>
  );
};

export default QueueStep2Preview;
